(() => {
  const initialize = (root) => {
    if (root.dataset.initialized === 'scroll-v2') return;
    root.dataset.initialized = 'scroll-v2';
    const canvas = root.querySelector('canvas');
    const context = canvas?.getContext('2d');
    if (!context) return;
    const preference = matchMedia('(prefers-reduced-motion: reduce)');
    const configuredDistance = Number(root.dataset.cycleViewports);
    const cycleViewports = configuredDistance > 0 ? configuredDistance : 1;
    let viewportHeight = document.documentElement.clientHeight || innerHeight;
    let viewportWidth = document.documentElement.clientWidth;
    let logoWidth = 241.5;
    const dotTravel = [0, 1, -0.662, -0.662, 1, 0, -1, 0.663, 0.663, -1];
    let footerStart = Infinity;
    let maxScroll = 0;
    let frame = -1;
    let raf = 0;
    let layoutDirty = true;
    let disposed = false;
    let ready = false;
    let failed = false;
    let sprite;
    const controller = new AbortController();
    const options = { passive: true, signal: controller.signal };
    const setState = (state) => {
      if (root.dataset.state !== state) root.dataset.state = state;
    };
    const measure = () => {
      const viewport = document.documentElement.clientHeight || innerHeight;
      const width = document.documentElement.clientWidth;
      if (width !== viewportWidth || !matchMedia('(pointer: coarse)').matches) {
        viewportHeight = viewport;
        viewportWidth = width;
      }
      maxScroll = Math.max(0, document.documentElement.scrollHeight - viewport);
      const footer = document.querySelector('footer.site-footer') || document.querySelector('footer');
      footerStart = footer ? Math.max(0, footer.getBoundingClientRect().top + scrollY - viewport) : maxScroll;
      logoWidth = Math.max(1, root.getBoundingClientRect().width);
      frame = -1;
      layoutDirty = false;
    };
    const render = () => {
      raf = 0;
      if (disposed) return;
      if (!root.isConnected) { dispose(); return; }
      if (layoutDirty) measure();
      const distance = Math.max(0, Math.min(scrollY, maxScroll));
      if (preference.matches) { setState('reduced-motion'); return; }
      if (distance <= 0) { setState('top'); return; }
      if (distance >= footerStart) { setState('footer'); return; }
      if (failed) { setState('asset-error'); return; }
      if (!ready) { setState('loading'); return; }
      const elapsed = distance * 1.25 / (Math.max(1, viewportHeight) * cycleViewports / 2);
      const next = elapsed < 0.75
        ? Math.min(59, Math.max(38, Math.floor((1.25 + elapsed) * 30 + 1e-8)))
        : 60 + Math.min(59, Math.floor((((elapsed - 0.75) % 2 + 2) % 2) * 30 + 1e-8));
      if (next !== frame) {
        const slot = next - 38;
        const sourceX = (slot % 8) * canvas.width;
        const sourceY = Math.floor(slot / 8) * canvas.height;
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(sprite, sourceX, sourceY, canvas.width, canvas.height, 0, 0, canvas.width, canvas.height);
        const extraTravel = next < 73 ? 0 : dotTravel[(next - 72) % 10];
        if (extraTravel) {
          const offset = extraTravel * canvas.width / logoWidth;
          context.clearRect(233, 0, 34, 32);
          context.drawImage(sprite, sourceX + 233, sourceY, 34, 32, 233 + offset, 0, 34, 32);
        }
        frame = next;
        root.dataset.frame = String(next);
        root.dataset.dotTravel = String(extraTravel);
      }
      setState('scrubbing');
    };
    const schedule = () => {
      if (!raf && !disposed && !document.hidden) raf = requestAnimationFrame(render);
    };
    const remeasure = () => { layoutDirty = true; schedule(); };
    const loadSprite = () => {
      if (sprite || preference.matches || disposed) return;
      sprite = new Image();
      sprite.decoding = 'async';
      sprite.onload = () => {
        if (disposed) return;
        if (sprite.naturalWidth !== canvas.width * 8 || sprite.naturalHeight !== canvas.height * 11) {
          failed = true;
        } else {
          ready = true;
        }
        remeasure();
      };
      sprite.onerror = () => { failed = true; schedule(); };
      sprite.src = root.dataset.sprite;
    };
    const observer = new ResizeObserver(remeasure);
    const dispose = () => {
      disposed = true;
      cancelAnimationFrame(raf);
      controller.abort();
      observer.disconnect();
      if (sprite) { sprite.onload = null; sprite.onerror = null; }
    };
    observer.observe(document.documentElement);
    observer.observe(document.body);
    window.addEventListener('scroll', schedule, options);
    window.addEventListener('resize', remeasure, options);
    window.addEventListener('pageshow', remeasure, options);
    document.addEventListener('load', remeasure, { capture: true, passive: true, signal: controller.signal });
    document.addEventListener('visibilitychange', schedule, options);
    preference.addEventListener('change', () => { loadSprite(); schedule(); }, options);
    document.addEventListener('shopify:section:load', remeasure, options);
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(root)) dispose();
      else remeasure();
    }, options);
    document.fonts?.ready.then(() => { if (!disposed) remeasure(); });
    render();
    loadSprite();
  };
  const scan = () => document.querySelectorAll('.site-header [data-logo-motion][data-motion-mode="scroll"]').forEach(initialize);
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
